module.exports = __webpack_public_path__ + "static/media/Japanese-alphabet.21bcebb1.jpg";